import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Check, X } from "lucide-react";
import { api } from "@/lib/api";
import { PageTitle } from "@/admin/AdminLayout";

const Mark = ({ ok, label }) => <span title={label} className={`inline-flex items-center justify-center w-6 h-6 ${ok ? "text-green-500" : "bg-[var(--accent)]/15 text-accent"}`}>{ok ? <Check size={14} /> : <X size={14} />}</span>;

export default function MatrixAdmin() {
  const [m, setM] = useState(null);
  useEffect(() => { api.get("/admin/matrix").then((r) => setM(r.data)); }, []);
  if (!m) return null;
  return (
    <div data-testid="admin-matrix-page">
      <PageTitle>Missing content <span className="text-accent text-xl" data-testid="matrix-missing-count">{m.missing_count} gaps</span></PageTitle>
      <p className="text-sm text-[var(--muted)] mb-6">Each cell shows text (T) and audio (A) for an artwork × language. Red = missing.</p>
      <div className="overflow-x-auto">
        <table className="admin-table text-sm min-w-full" data-testid="matrix-table">
          <thead><tr><th>Artwork</th><th>Photo</th>{m.languages.map((l) => <th key={l.code}>{l.name} <span className="text-[var(--muted)] normal-case">(T / A)</span></th>)}</tr></thead>
          <tbody>
            {m.rows.map((r) => (
              <tr key={r.id} data-testid={`matrix-row-${r.id}`}>
                <td><Link to={`/admin/artworks/${r.id}`} className="font-semibold hover:text-accent">{r.title}</Link></td>
                <td><Mark ok={r.image} label="Photo" /></td>
                {m.languages.map((l) => <td key={l.code} data-testid={`matrix-cell-${r.id}-${l.code}`}><span className="inline-flex gap-1"><Mark ok={r.cells[l.code]?.text} label="Text" /><Mark ok={r.cells[l.code]?.audio} label="Audio" /></span></td>)}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
